import Cookies from 'js-cookie'

const state = {
	sidebar: {
		opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
	},
	device: 'desktop',
	axiosPromiseArr:[] // 取消请求token数组
}

const mutations = {
	TOGGLE_SIDEBAR: state => {
		state.sidebar.opened = !state.sidebar.opened
		state.sidebar.withoutAnimation = false
		if (state.sidebar.opened) {
			Cookies.set('sidebarStatus', 1)
		} else {
			Cookies.set('sidebarStatus', 0)
		}
	},
	CLOSE_SIDEBAR: (state, withoutAnimation) => {
		Cookies.set('sidebarStatus', 0)
		state.sidebar.opened = false
		state.sidebar.withoutAnimation = withoutAnimation
	},
	TOGGLE_DEVICE: (state, device) => {
		state.device = device
	},
	SET_SIZE: (state, size) => {
		state.size = size
		Cookies.set('size', size)
	},
	PUSH_PROMISE:(state, cancel)=> {
		state.axiosPromiseArr.push(cancel)
	},
	CLEAR_PROMISE:({
		axiosPromiseArr
	})=> {
		axiosPromiseArr.forEach(item => {
			 item.cancel() // 路由跳转之前，终止上一个页面正在请求的内容
		})
		axiosPromiseArr = []
	}
}

const actions = {
	toggleSideBar({
		commit
	}) {
		commit('TOGGLE_SIDEBAR')
	},
	closeSideBar({
		commit
	}, {
		withoutAnimation
	}) {
		commit('CLOSE_SIDEBAR', withoutAnimation)
	},
	toggleDevice({
		commit
	}, device) {
		commit('TOGGLE_DEVICE', device)
	},
	setSize({
		commit
	}, size) {
		commit('SET_SIZE', size)
	},
	pushPromise({
		commit
	}, cancel){
		commit('PUSH_PROMISE',cancel)
	},
	clearPromise({
		commit
	} ){
		commit('CLEAR_PROMISE')
	}
	
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
